/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class NyrSetupDefinitionTilesApi {
  async GetJsonDataObject(jsonData : string) : Promise<sis.NyrSetupDefinitionTilesData> {
    return await componentApi.call('sis', 'sis-nyrsetup-definitiontiles', 'NyrSetupDefinitionTilesApi', 'GetJsonDataObject', {
      jsonData,
    });
  }
}
export default new NyrSetupDefinitionTilesApi()
